import React from "react";
import { Link } from "react-router-dom";
import img1 from './images/illustration/brand-3.png';
const Nav = () => {
  return (
    <>
    <nav class="navbar navbar-expand-lg bg-dark ">
  <div class="container-fluid ">
    <Link class="navbar-brand " to="/Home"><img src={img1} alt="" className="w-25 h-25"/></Link>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse " id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto mb-2 mb-lg-0 gap-4 me-3">
        <li class="nav-item">
          <Link class="nav-link active text-light" aria-current="page" to="/Home">Home</Link>
        </li>
        <li class="nav-item">
          <Link class="nav-link active text-light" aria-current="page" to="/About">About</Link>
        </li>
        <li class="nav-item">
          <Link class="nav-link active text-light" aria-current="page" to="/Services">Services</Link>
        </li>
        {/* <li class="nav-item">
          <Link class="nav-link text-light" to="/Pages">pages</Link>
        </li> */}
        <li class="nav-item dropdown">
        <Link class="nav-link dropdown-toggle text-light" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" >pages</Link>
          
          <ul class="dropdown-menu">
            <li><Link class="dropdown-item" to="/About">About</Link></li>
            <li><Link class="dropdown-item" to="/Services">Services</Link></li>
            
          </ul>
        </li>
        <li class="nav-item dropdown">
          <Link class="nav-link  text-light disabled" to="/Blog" role="button" data-bs-toggle="dropdown" aria-expanded="false">
           Blog
          </Link>
          <ul class="dropdown-menu text-light">
            <li><Link class="dropdown-item" to="#">Action</Link></li>
            <li><Link class="dropdown-item" to="#">Another action</Link></li>
            
          </ul>
        </li>

        <li class="nav-item">
          <Link class="nav-link active text-light" aria-current="page" to="/Contact">Contact</Link>
        </li>
        
      </ul>
      <form class="d-flex" role="search">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
        <button class="btn btn-outline-success" type="submit">Search</button>
      </form>
    </div>
  </div>
</nav>
    </>
  );
};

export default Nav;
